import React from 'react';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../Components/LogoSpinner/Spinner';

function BulkCostingExchangeModal({ show, toggle, onChangeExchangeValue, hadleSumbitExchange, exChangeValue, showLoader, errors }) {
  const { t } = useTranslation('common');

  return (
    <Modal className="common-custom-modal" size="md" show={show} onHide={toggle} backdrop="static">
      <Modal.Header>
        <Modal.Title>{t('RANGE_PLANS.PRODUCT_LIST.BULK_COSTING_EXCHANGE.MODAL_TITLE_COSTING')}</Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {showLoader ? (
          <Spinner />
        ) : (
          <form>
            <div className="common-input-control">
              <p className="field-name">
                {t('RANGE_PLANS.PRODUCT_LIST.BULK_COSTING_EXCHANGE.EXCHANGE_RATE')}
                <span className="asterisk">*</span>
              </p>
              <input type="number" className="form-control" value={exChangeValue} onChange={(e) => onChangeExchangeValue(e.target.value)} />
            </div>
            {errors && <span className="error-message"> {t('RANGE_PLANS.PRODUCT_LIST.BULK_COSTING_EXCHANGE.EXCHANGE_RATE_REQUIRED_ERROR')}</span>}
            <div className="common-model-footer mt-24">
              <button
                className="btn p-0"
                type="button"
                onClick={hadleSumbitExchange}
                aria-label={t('RANGE_PLANS.PRODUCT_LIST.BULK_COSTING_EXCHANGE.SAVE_BUTTON')}
              >
                <span className="icon-Tick-1 f-24" />
              </button>
            </div>
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default BulkCostingExchangeModal;
